import { render, staticRenderFns } from "./VineyardWaterMetric.vue?vue&type=template&id=74c07e84&scoped=true&"
import script from "./VineyardWaterMetric.vue?vue&type=script&lang=js&"
export * from "./VineyardWaterMetric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c07e84",
  null
  
)

export default component.exports